import styled from "styled-components";

export const BtnApproveFormWidgetStyled = styled.div`
  text-wrap: nowrap;
`;
